import FontFaceObserver from 'fontfaceobserver';

const f = obj => new FontFaceObserver(obj);

const fonts = [
  f('Graphik Web'),
  f('Graphik Web', {
    weight: 300,
  }),
  f('Graphik Web', {
    weight: 700,
  }),
];

Promise.all(fonts.map(font => font.load())).then(() => {
  document.documentElement.classList.add('fonts-loaded');
  // Optimization for Repeat Views
  sessionStorage.foutFontsLoaded = true;
});



// WEBPACK FOOTER //
// ./src/js/font-load.js